module.exports = __webpack_public_path__ + "media/images/icon__twitter@2x-4a979dac17279c47fb6cdedb155c6c93.png";